/**
 * A parameter used for running a process
 */
export class ProcessParameter {
  /**
   * The name of the parameter Eg. '-d', '-f' etc.
   */
  name: string;

  /**
   * The value of the parameter
   */
  value: any;
}
